import React from "react";
import {useState} from "../state/useState";
import {order} from "../service/RechargeService";
import {redirectTo} from "../state/action";

export function BankFailureMessage({history}) {

    let [state, dispatch] = useState();


    return <>
        <div className="page_title2">
            <div className="container">

                <div className="title">
                    <h1>Greška kod obrade zahtjeva</h1></div>
            </div>
        </div>
        <div
            className="clearfix">
        </div>
        <div className="container">
            <div className="content_fullwidth">
                <div className="reg_form">
                    <p>
                        <h3 className="nocaps">Pokušaj ponovo!</h3>
                        <div>
                            <br/>
                            <br/>
                            <blockquote><p>Banka je odbila zahtjev!</p></blockquote>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                        </div>
                    </p>

                    <div class=" left"><a href=" xkvik_index.html" class=" knowmore_but"><i
                        class=" fa fa-hand-o-left fa-lg"></i>
                        NAZAD</a></div>
                </div>
            </div>
        </div>
    </>
}